import { apiClient } from '@/shared/services/http/http.service'
import { SURVEY_ENDPOINTS } from '../constants/endpoints.constant.js'

export async function sendInvitations(versionUuid, { recipients, subject, message }) {
  const url = SURVEY_ENDPOINTS.SEND_INVITATIONS.replace(':id', versionUuid)
  const response = await apiClient('generic-survey').post(url, { recipients, subject, message })

  if (response.status < 200 || response.status >= 300) {
    throw new Error(`Send invitations failed with status ${response.status}`)
  }

  return response.data?.data ?? response.data
}
